import ErrorBoundary, { ErrorBoundaryProps, ErrorBoundaryState } from './ErrorBoundary';

export type { ErrorBoundaryProps, ErrorBoundaryState };

export default ErrorBoundary;
